import React from 'react';
import AdminProvisionForm from './AdminProvisionForm';
import AdminProvisionTable from './AdminProvisionTable';

const AdminProvisionContainer = () => {
    return (
        <div className='admin-provision-container' data-testid="admin-provision-main-container">
            <AdminProvisionForm/>
            <AdminProvisionTable />
        </div>
    );
};

export default AdminProvisionContainer;
